// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#MapTip {\n    position: absolute;\n    background: white;\n    box-shadow: 0px 2px 5px rgba(136, 136, 136, 0.5);\n    border-radius: 0.5em;\n    border: 1px solid #bbb;\n}\n\n#MapTip > div {\n    padding: 0.25em;\n}\n\n#MapTip > div:not(:last-child) {\n    border-bottom: 1px solid #bbb;\n}\n", ""]);
// Exports
module.exports = exports;
